import { Dispatch } from 'react';
import { apiClient, apiErrorHandler, ADMIN_URL } from 'src/app/common/network';
import {
  AWARD_STATUS_OPERATION,
  UPDATE_AWARD_STATUS,
  WalletAwardListItem,
  WalletAwardListParam,
  WalletAwardListRes,
  WalletUpdateAwardStatusRes,
} from '../types/award-type';
import { GetWalletAwardDetail, WalletAwardEditItem } from '../pages/Award/View/components/AwardDetail.util';
import { WalletAssignedAwardListParam, WalletAssignedAwardListRes } from '../types/assigned-award-type';
import { preFillZero } from 'src/app/common/utils/common-utils';
import { formatDay, getError } from '../comm';

const AWARDS_BASE_URL = `${ADMIN_URL}/pruwallet/admin/awards`;

export const createWalletAward = async (
  data: WalletAwardEditItem,
  dispatch?: Dispatch<any>,
): Promise<WalletAwardListItem> => {
  return apiClient
    .post<WalletAwardListItem>(AWARDS_BASE_URL, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw apiErrorHandler(getError(err), dispatch);
    });
};

export const getWalletAwardList = async (
  params: WalletAwardListParam,
  dispatch?: Dispatch<any>,
): Promise<WalletAwardListRes> => {
  const apiParams = {
    ...params,
    awardId: params.awardId ? params.awardId : undefined,
    awardNameZh: params.awardNameZh ? params.awardNameZh : undefined,
    awardNameEn: params.awardNameEn ? params.awardNameEn : undefined,
    status: params.status ? params.status : undefined,
    redemptionStartDate: formatDay(params.redemptionStartDate),
    redemptionEndDate: formatDay(params.redemptionEndDate),
    awardAvailabilityStartDate: formatDay(params.awardAvailabilityStartDate),
    awardAvailabilityEndDate: formatDay(params.awardAvailabilityEndDate),
  };
  return apiClient
    .get<WalletAwardListRes>(AWARDS_BASE_URL, { params: apiParams })
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(getError(err), dispatch);
    });
};

export const getWalletAwardById = async (id: string, dispatch?: Dispatch<any>): Promise<GetWalletAwardDetail> => {
  return apiClient
    .get<any>(`${AWARDS_BASE_URL}/${id}`)
    .then((response) => {
      return response?.data?.data;
    })
    .catch((err) => {
      throw apiErrorHandler(getError(err), dispatch);
    });
};

export const modifyWalletAward = async (
  code: string,
  data: WalletAwardEditItem,
  dispatch?: Dispatch<any>,
): Promise<void> => {
  return apiClient
    .put<void>(`${AWARDS_BASE_URL}/${code}`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw apiErrorHandler(getError(err), dispatch);
    });
};

export const getWalletAssignedAwardList = async (
  params: WalletAssignedAwardListParam,
  dispatch?: Dispatch<any>,
): Promise<WalletAssignedAwardListRes> => {
  const apiParams = {
    limit: params.pageSize,
    offset: (params.page - 1) * params.pageSize,
    awardId: params.awardId ? params.awardId : undefined,
    agentCode: params.agentCode ? preFillZero(params.agentCode) : undefined,
    promoCode: params.promoCode ? params.promoCode : undefined,
    markedAsUsed: params.markedAsUsed ? params.markedAsUsed === 'Y' : undefined,
    allowRedemptionDateFrom: formatDay(params.redemptionStartDate),
    allowRedemptionDateTo: formatDay(params.redemptionEndDate),
    validityDateFrom: formatDay(params.validityStartDate),
    validityDateTo: formatDay(params.validityEndDate),
  };
  return apiClient
    .get<WalletAssignedAwardListRes>(`${AWARDS_BASE_URL}/assigned-enquiry`, { params: apiParams })
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(getError(err), dispatch);
    });
};

export const updatedWalletAwardStatus = async (
  id: string,
  params: UPDATE_AWARD_STATUS,
  operation: AWARD_STATUS_OPERATION,
  dispatch?: Dispatch<any>,
): Promise<WalletUpdateAwardStatusRes> => {
  const req =
    operation === AWARD_STATUS_OPERATION.PAUSE || operation === AWARD_STATUS_OPERATION.ACTIVE
      ? apiClient.patch<WalletUpdateAwardStatusRes>(`${AWARDS_BASE_URL}/${id}/${operation}`, { ...params })
      : apiClient.post<WalletUpdateAwardStatusRes>(`${AWARDS_BASE_URL}/${id}/${operation}`, { ...params });
  return req
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(getError(err), dispatch);
    });
};
